import { useQuery } from '@tanstack/react-query'
import { getLiveOperations } from '../services/liveOperationsApi'
import { LIVE } from '../utils/polling'

/**
 * The ONE query key for "what is running now". Overview's Live Operations
 * panel and Live Activity's banner both read it, and the SignalR hub
 * invalidates it, so there is one poll against the endpoint rather than one
 * per consumer.
 */
export const LIVE_OPERATIONS_KEY = ['observatory', 'liveOperations'] as const

/**
 * What the worker has recorded as running right now, on the LIVE interval —
 * chunk phases and heartbeats genuinely move second to second.
 *
 * CACHE-KEY HAZARD: the fixture hook of the same name in `hooks/useOverview.ts`
 * uses this SAME key with an incompatible payload (`LiveOperation[]`). A page
 * that mounts both would have the two queries overwrite each other's cache
 * entry. Import this one, never that one, and never mount it on a page that
 * still imports the fixture hook.
 *
 * Staleness is the server's call (`isHeartbeatStale`, `isStale`,
 * `liveRunCount`), made with the worker's own published rule. Nothing here
 * re-derives it from the browser clock.
 */
export function useLiveOperations() {
  return useQuery({
    queryKey: LIVE_OPERATIONS_KEY,
    queryFn: getLiveOperations,
    refetchInterval: LIVE,
  })
}
